/* Consent-gated, tab-scoped identification for Shopify's native recovery.
 * No recovery mail, custom cart events, cookie overrides or PII diagnostics.
 */
(() => {
  const key = 'hhRecoveryIdentity';
  const lifetime = 30 * 60 * 1000;
  let identity = null, retry = null, expiry = null;
  let attempts = 0, featureRequested = false, hadConsent = false;
  const valid = value => typeof value === 'string' && value.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const status = value => {
    document.documentElement.dataset.hhRecoveryState = value;
    const output = document.getElementById('HhRecoveryDiagnostic');
    if (output) output.textContent = `Basket reminder identification: ${value}. This does not confirm an email send.`;
  };
  const removeStored = () => { try { window.sessionStorage.removeItem(key); } catch {} };
  const clear = reason => {
    identity = null;
    window.clearTimeout(retry);
    window.clearTimeout(expiry);
    retry = expiry = null;
    removeStored();
    status(reason);
  };
  const scheduleExpiry = () => {
    window.clearTimeout(expiry);
    expiry = window.setTimeout(() => clear('expired'), Math.max(0, identity.expiresAt - Date.now()));
  };
  const attempt = () => {
    retry = null;
    if (!identity) return;
    if (Date.now() >= identity.expiresAt) { clear('expired'); return; }
    const shopify = window.Shopify;
    const privacy = shopify?.customerPrivacy;
    try {
      if (!privacy && !featureRequested && typeof shopify?.loadFeatures === 'function') {
        featureRequested = true;
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) resume();
        });
      }
      if (!privacy) status('waiting-for-privacy');
      else if (privacy.marketingAllowed?.() !== true || privacy.analyticsProcessingAllowed?.() !== true) {
        // Pending signup stays memory-only until both native permissions exist.
        removeStored();
        if (hadConsent) { clear('consent-withdrawn'); return; }
        status('waiting-for-consent');
      } else {
        hadConsent = true;
        try { window.sessionStorage.setItem(key, JSON.stringify(identity)); } catch {}
        if (typeof shopify?.analytics?.visitor !== 'function') status('waiting-for-analytics');
        else if (shopify.analytics.visitor({ email: identity.email }, { appId: '435798376449' }) === true) {
          status('accepted-by-shopify');
          return;
        } else status('not-yet-accepted');
      }
    } catch { status('retrying'); }
    if (identity && attempts++ < 60 && retry === null) retry = window.setTimeout(attempt, 1000);
  };
  const resume = () => {
    if (identity) scheduleExpiry();
    attempts = 0;
    window.clearTimeout(retry);
    attempt();
  };
  document.addEventListener('visitorConsentCollected', resume);
  window.addEventListener('pageshow', resume);
  window.addEventListener('pagehide', () => {
    window.clearTimeout(retry);
    window.clearTimeout(expiry);
  });
  window.HawthornRecovery = {
    identify(value, marketingConsent) {
      if (marketingConsent !== true || typeof value !== 'string' || !valid(value.trim())) return;
      identity = { email: value.trim(), expiresAt: Date.now() + lifetime };
      hadConsent = false;
      scheduleExpiry();
      resume();
    }
  };
  status('no-signup');
  // Opt-in owner QA surface contains state only, never the email or code.
  if (new URLSearchParams(window.location.search).get('hh_recovery_debug') === '1') {
    const output = document.createElement('output');
    output.id = 'HhRecoveryDiagnostic';
    output.style.cssText = 'position:fixed;bottom:8px;left:8px;right:8px;z-index:99999;padding:12px;background:#fff;color:#163c2d;border:1px solid #163c2d;font:14px/1.4 sans-serif;pointer-events:none';
    document.body.appendChild(output);
    status('no-signup');
  }
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(key) || 'null');
    if (saved && valid(saved.email) && Number.isFinite(saved.expiresAt) && saved.expiresAt > Date.now() && saved.expiresAt <= Date.now() + lifetime) {
      identity = { email: saved.email, expiresAt: saved.expiresAt };
      hadConsent = true;
      scheduleExpiry();
      resume();
    } else removeStored();
  } catch { removeStored(); }
})();
